import request from '@/router/axios';

// 列表 - 分页查询（去重）
export const getList = (params) => {
  return request({
    url: '/api/produce/base-spare-part-apply/select/distinct/page',
    method: 'post',
    data: params
  })
}

// 详情 - 根据ID查询
export const getDetail = (id) => {
  return request({
    url: '/api/produce/base-spare-part-apply/select/id',
    method: 'get',
    params: { id }
  })
}

// 新增备件申请
export const add = (data) => {
  return request({
    url: '/api/produce/base-spare-part-apply/insert',
    method: 'post',
    data
  })
}

// 提交申请
export const apply = (data) => {
  return request({
    url: '/api/produce/base-spare-part-apply/apply',
    method: 'post',
    data
  })
}

// 修改备件申请
export const update = (data) => {
  return request({
    url: '/api/produce/base-spare-part-apply/update',
    method: 'post',
    data
  })
}

// 删除申请
export const remove = (id) => {
  return request({
    url: '/api/produce/base-spare-part-apply/delete/id',
    method: 'post',
    params: { id }
  })
}

// 批量删除
export const removeBatch = (ids) => {
  return request({
    url: '/api/produce/base-spare-part-apply/delete/ids',
    method: 'post',
    params: { ids }
  })
}

// 通过申请（通过修改状态实现）
export const approve = (id, data) => {
  return request({
    url: '/api/produce/base-spare-part-apply/update',
    method: 'post',
    data: { id, applyStatus: 2, ...data } // 2表示已通过
  })
}

// 拒绝申请（通过修改状态实现）
export const reject = (id, data) => {
  return request({
    url: '/api/produce/base-spare-part-apply/update',
    method: 'post',
    data: { id, applyStatus: 3, ...data } // 3表示已拒绝
  })
}

// 重新审核（通过修改状态实现）
export const reReview = (id) => {
  return request({
    url: '/api/produce/base-spare-part-apply/update',
    method: 'post',
    data: { id, applyStatus: 1 } // 1表示待审核
  })
}

// 打印申请单
export const printApplication = (id) => {
  return request({
    url: '/api/produce/base-spare-part-apply/print',
    method: 'get',
    params: { id }
  })
}

// 导出PDF
export const exportPDF = (id) => {
  return request({
    url: '/api/produce/base-spare-part-apply/export/pdf',
    method: 'get',
    params: { id },
    responseType: 'blob'
  })
}



